import type { UnderSaturatedOilViscosityParameters } from "../../d";

export function underSaturatedOilViscosityCalculator(
  params: UnderSaturatedOilViscosityParameters
): {
  undersaturatedOilViscosity: number;
} {
  // NOT IMPLEMENTED ACCORDING TO SPREADSHEET
  return {
    undersaturatedOilViscosity: 0
  };
}
